export default __webpack_public_path__ + "img/428f025e3956693177b317573105a55a.png";